import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function SettingLayout() {
  const location = useLocation();
  const userlogin = useSelector((state) => state.auth);
  return (
    <div className="grid grid-cols-1 max-w-[570px] px-4 mt-5 mx-auto gap-6  [&>div]:rounded-[15px]   pb-10  ">
      <h2
        className="text-white  mt-3 mb-2 text-[40px] font-bold leading-[50px] tracking-normal text-center "
        style={{ fontFamily: "Gilroy", fontWeight: "700", textAlign: "left" }}
      >
        Settings
      </h2>
      <div className=" flex items-center gap-6 !rounded-none [&>a]:text-nowrap  [&>a]:text-[18px] [&>a]:font-[600] [&>a]:leading-[22px] [&>a]:text-left [&>a]:text-white min-w-[540px] overflow-x-auto CustomScrollbar pb-1 ">
        <NavLink
          to={"/profile-setting"}
          className={`border-b-[2px] border-b-transparent pb-1   ${
            location.pathname === "/profile-setting"
              ? " !border-b-[#01ff91]   "
              : ""
          }`}
        >
          Profile
        </NavLink>
        <NavLink
          to={"/payment-setting"}
          className={`border-b-[2px] border-b-transparent pb-1   ${
            location.pathname === "/payment-setting"
              ? " !border-b-[#01ff91]   "
              : ""
          }`}
        >
          Payment
        </NavLink>
        <NavLink
          to={"/stream-setting"}
          className={`border-b-[2px] border-b-transparent pb-1   ${
            location.pathname === "/stream-setting"
              ? " !border-b-[#01ff91]   "
              : ""
          }`}
        >
          Stream
        </NavLink>
        <NavLink
          to={"/notifications-setting"}
          className={`border-b-[2px] border-b-transparent pb-1   ${
            location.pathname === "/notifications-setting"
              ? " !border-b-[#01ff91]   "
              : ""
          }`}
        >
          Notifications
        </NavLink>
        {/* {["bajay", "Velo_City"].includes(userlogin.sponsaUserName) && (
          <NavLink
            to={"/chatbot-setting"}
            className={`border-b-[2px] border-b-transparent pb-1   ${
              location.pathname === "/chatbot-setting"
                ? " !border-b-[#01ff91]   "
                : ""
            }`}
          >
            Chatbot
          </NavLink>
        )} */}
        <NavLink
          to={"/chatbot-setting"}
          className={`border-b-[2px] border-b-transparent pb-1   ${
            location.pathname === "/chatbot-setting"
              ? " !border-b-[#01ff91]   "
              : ""
          }`}
        >
          Chatbot
        </NavLink>
        <NavLink
          to={"/Integrations-setting"}
          className={`border-b-[2px] border-b-transparent pb-1   ${
            location.pathname === "/Integrations-setting"
              ? " !border-b-[#01ff91]   "
              : ""
          }`}
        >
          Integrations
        </NavLink>
        {/* <NavLink
          to={"/donothon-timer-setting"}
          className={`border-b-[2px] border-b-transparent pb-1   ${
            location.pathname === "/donothon-timer-setting"
              ? " !border-b-[#01ff91]   "
              : ""
          }`}
        >
          Donothon Timer
        </NavLink> */}
      </div>
      <Outlet />
    </div>
  );
}

export default SettingLayout;
